import React from 'react';
import { toast } from 'sonner';
import { NOAH_MOODS, resolveMood } from './noahMoods';

const readMode = () => localStorage.getItem('deal_noah_expression') || 'auto';

/** Toast con la expresión de Noah: celebra ventas, se enfoca al escalar, alerta en urgencias. */
export function noahToast(mood, title, description, opts = {}) {
  const key = resolveMood(mood, readMode());
  const pose = key ? NOAH_MOODS[key] : null;

  toast.custom(
    (id) => (
      <div
        data-testid={`noah-toast-${mood}`}
        onClick={() => toast.dismiss(id)}
        className="flex items-center gap-3 w-[340px] max-w-[90vw] rounded-2xl bg-brand-deep border border-brand-green/40 shadow-xl p-3 cursor-pointer"
      >
        {pose && <img src={pose.src} alt={pose.alt} className="h-16 w-auto shrink-0 drop-shadow" />}
        <div className="min-w-0">
          <p className="text-sm font-semibold text-brand-butter truncate">{title}</p>
          {description && <p className="text-xs text-white/80 line-clamp-2">{description}</p>}
        </div>
      </div>
    ),
    { duration: opts.duration || 5000 }
  );
}

export default noahToast;
